import React from "react";
import { Box } from "../../../components";
import { useCustomTranslation } from "../../../helpers/translateHelpers";
import { CustomerPortalContactPersonInfo } from "../../../common/models";

interface Props {
  contactPeople: CustomerPortalContactPersonInfo[];
  primaryContactPersonId: string;
}

const CustomerContactPeopleBox: React.FC<Props> = ({
  contactPeople,
  primaryContactPersonId,
}): React.ReactElement => {
  const { tCustomer } = useCustomTranslation();

  return (
    <Box
      className="mt-8" // w-1/2 pr-2"
      title={tCustomer("contact_people")}
      items={contactPeople.map((contactPerson) => ({
        label: `${contactPerson.fullName} ${contactPerson.position && `- ${contactPerson.position}`}`,
        value: (
          <div className="-mt-1.5 font-bold sm:mt-0 sm:text-right">
            <div className="sm:mt-0">{contactPerson.email}</div>
            {contactPerson.phone && (
              <div
                className={`${contactPerson.email ? "-mt-2" : "mt-0"} sm:mt-0`}
              >
                {`${contactPerson.phone.prefix}${contactPerson.phone.number}`}
              </div>
            )}
          </div>
        ),
        subLabel:
          contactPerson.id === primaryContactPersonId
            ? tCustomer("primary_contact_person")
            : undefined,
      }))}
    />
  );
};

export default CustomerContactPeopleBox;
